import ChevronLeftIcon from "@heroicons/react/20/solid/ChevronLeftIcon";
import Balance from "react-wrap-balancer";

import useFCSubscriptionStore from "@hsl/fc-subscription/store";

import { Translate } from "../../../../hooks/useTranslation";
import EnvelopeCheckIcon from "../../../icons/EnvelopeCheck";
import { useHideTabBar } from "../../useHideTabBar";
import { Card } from "../Card";

export const DACHScreen = () => {
    useHideTabBar();
    const closeDACHScreen = useFCSubscriptionStore(
        (state) => state.closeDACHScreen,
    );

    return (
        <div className="bg-white-smoke min-h-[50vh] w-full pb-16">
            <div className="container mx-auto !max-w-[898px]">
                <button
                    onClick={closeDACHScreen}
                    className="text-taupe-grey my-3 inline-flex flex-row items-center py-2 pr-2"
                >
                    <ChevronLeftIcon className="mr-1.5 inline-block h-5 w-5" />
                    <Translate>Back to fund centre</Translate>
                </button>
                <Card className="flex flex-col items-center gap-4 py-12">
                    <EnvelopeCheckIcon className="w-24 shrink-0" />
                    <div className="flex max-w-md flex-col gap-4 text-center">
                        <h1 className="text-xl">
                            <Translate>
                                Thank you for verifying your email address
                            </Translate>
                        </h1>
                        <Balance as="p">
                            <Translate>
                                Thank you for verifying your email address. To
                                comply with GDPR regulations you will now
                                receive another email to confirm your
                                subscriptions. Once confirmed, your
                                subscriptions will be activated.
                            </Translate>
                        </Balance>
                        <p>
                            <Translate>Please check your inbox</Translate>.
                        </p>
                    </div>
                </Card>
            </div>
        </div>
    );
};
